import { all, fork } from 'redux-saga/effects';
import bookmarksSaga from './bookmarks';
import deviationsSaga from './deviations';
import modalSaga from './modal';
import presetsSaga from './presets';
import scheduleSaga from './schedule';
import statusEditSaga from './statusEdit';
import writerSaga from './writer';
import originalsSaga from './originals';

export default function* rootSaga() {
  yield all([
    fork(bookmarksSaga),
    fork(deviationsSaga),
    fork(modalSaga),
    fork(presetsSaga),
    fork(scheduleSaga),
    fork(statusEditSaga),
    fork(writerSaga),
    fork(originalsSaga),
  ]);
}
